export default __webpack_public_path__ + "static/media/carpenter-works-with-tree.f0106f90.webp";